import {
	FETCH_AGENDA,
	FETCH_AGENDA_ITEM,
	CLEAR_AGENDA,
	CLEAR_AGENDA_ITEM,
	UPDATE_AGENDA_ITEM,
	CREATE_AGENDA_ITEM,
	DELETE_AGENDA_ITEM,
	ADD_GROUPS_TO_AGENDA_ITEM,
	REMOVE_GROUPS_FROM_AGENDA_ITEM,
	ADD_MATERIAL_TO_AGENDA_ITEM,
	DELETE_MATERIAL_FROM_AGENDA_ITEM,
	UPDATE_MATERIAL,
	ADD_GROUPS_TO_MATERIAL,
	REMOVE_GROUPS_FROM_MATERIAL,
	UPDATE_SELECTED_PERSON_OR_TRACK,
	UPDATE_SELECTED_VIEW,
	UPDATE_SELECTED_PERSON_OR_TRACK_NAME,
	CLEAR_AGENDA_FILTER_AND_SCROLL,
	SET_SCROLL_POSITION,
} from '../actions/actionTypes';

import { addGroups, removeGroups } from '@/redux/util/material.util';

const preState = {
	agenda: null,
	agendaItem: null,
	selectedPersonOrTrack: null,
	selectedPersonOrTrackName: null,
	selectedView: 'person',
	scrollPosition: 0,
};

const agendaReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const {
		type,
		agenda,
		agendaItem,
		agendaItemID,
		groupIDs,
		material,
		materials,
		materialID,
		selectedPersonOrTrack,
		selectedPersonOrTrackName,
		selectedView,
		scrollPosition,
	} = action;
	switch (type) {
		case FETCH_AGENDA:
			return { ...stateDup, agenda };
		case FETCH_AGENDA_ITEM:
			return { ...stateDup, agendaItem };
		case CLEAR_AGENDA:
			return { ...stateDup, agenda: preState.agenda };
		case CLEAR_AGENDA_ITEM:
			return { ...stateDup, agendaItem: preState.agendaItem };
		case CREATE_AGENDA_ITEM:
			return stateDup.agenda
				? { ...stateDup, agenda: [...stateDup.agenda, agendaItem] }
				: { ...stateDup, agenda: [agendaItem] };
		case ADD_GROUPS_TO_AGENDA_ITEM:
			stateDup.agendaItem = {
				...stateDup.agendaItem,
				groups: [...stateDup.agendaItem.groups, ...groupIDs],
			};
			return { ...stateDup };
		case REMOVE_GROUPS_FROM_AGENDA_ITEM:
			const idsToRemove = groupIDs.map(group => group.id);
			stateDup.agendaItem.groups = stateDup.agendaItem.groups.filter(
				group => !idsToRemove.includes(group.id)
			);
			return { ...stateDup, agendaItem: { ...stateDup.agendaItem } };
		case DELETE_AGENDA_ITEM:
			if (stateDup.agendaItem && stateDup.agendaItem.id === agendaItemID)
				stateDup.agendaItem = null;
			stateDup.agenda = stateDup.agenda.filter(item => item.id !== agendaItemID);
			return { ...stateDup };
		case UPDATE_AGENDA_ITEM:
			if (stateDup.agendaItem && agendaItem.id === stateDup.agendaItem.id)
				stateDup.agendaItem = { ...stateDup.agendaItem, ...agendaItem };
			if (stateDup.agenda)
				stateDup.agenda = stateDup.agenda.map(item =>
					item.id === agendaItem.id ? { ...item, ...agendaItem } : item
				);
			return { ...stateDup };
		case ADD_MATERIAL_TO_AGENDA_ITEM:
			stateDup.agendaItem = {
				...stateDup.agendaItem,
				materials: [...stateDup.agendaItem.materials, ...materials],
			};
			return { ...stateDup };
		case DELETE_MATERIAL_FROM_AGENDA_ITEM:
			stateDup.agendaItem = {
				...stateDup.agendaItem,
				materials: stateDup.agendaItem.materials.filter(m => m.id !== materialID),
			};
			return { ...stateDup };
		case UPDATE_MATERIAL:
			stateDup.agendaItem = {
				...stateDup.agendaItem,
				materials: stateDup.agendaItem.materials.map(m =>
					m.id === material.id ? { ...m, ...material } : m
				),
			};
			return { ...stateDup };
		case ADD_GROUPS_TO_MATERIAL:
			stateDup.agendaItem.materials = stateDup.agendaItem.materials.map(m => {
				if (m.id === materialID) addGroups(groupIDs, m);
				return m;
			});
			return { ...stateDup, agendaItem: { ...stateDup.agendaItem } };
		case REMOVE_GROUPS_FROM_MATERIAL:
			stateDup.agendaItem.materials = stateDup.agendaItem.materials.map(m => {
				if (m.id === materialID) removeGroups(groupIDs, m);
				return m;
			});
			return { ...stateDup, agendaItem: { ...stateDup.agendaItem } };
		case UPDATE_SELECTED_PERSON_OR_TRACK:
			return { ...stateDup, selectedPersonOrTrack };
		case UPDATE_SELECTED_PERSON_OR_TRACK_NAME:
			return { ...stateDup, selectedPersonOrTrackName };
		case UPDATE_SELECTED_VIEW:
			return {
				...stateDup,
				selectedView,
				selectedPersonOrTrack: null,
				selectedPersonOrTrackName: null,
			};
		case CLEAR_AGENDA_FILTER_AND_SCROLL:
			return {
				...stateDup,
				...preState,
				agendaItem: { ...stateDup.agendaItem },
			};
		case SET_SCROLL_POSITION:
			return { ...stateDup, scrollPosition };
		default:
			return stateDup;
	}
};

export default agendaReducer;
